const Location = () => {
    window.location.replace('https://the100club.notion.site/Mastermind-Location-Guide-to-NUS-Hangar-64e8132341774562acfc38e4509357fe?pvs=4');
};

export default Location;
